import { render, staticRenderFns } from "./buy.certification.vue?vue&type=template&id=2762a863"
import script from "./buy.certification.vue?vue&type=script&lang=js"
export * from "./buy.certification.vue?vue&type=script&lang=js"
import style0 from "./buy.certification.vue?vue&type=style&index=0&id=2762a863&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports